import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';
import { ApplicationAuthorizationActionType as AuthType } from '~shared/modules/application-event/constants';

export class GaTrackingIdamRegisterEvent implements GATrackingEvent {

  constructor(
    private event: string,
    private category: string,
    private action?: AuthType,
    private label?: string,
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.IdamSignUp;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.event,
      category: this.category,
      label: this.label,
      gtmCustom: {
        action: this.action,
      }
    };
  }
}
